var _path, _path2, _path3, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 831,
    height: 982,
    viewBox: "0 0 831 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.5 131C269.769 -89 361.5 -533 361.5 -533L-52.5 -59L-89 1150.5L152 1187C152 1187 411 1208.5 361.5 1098.5C312 988.5 421.829 377.368 341.5 131Z",
    fill: "#FFEDFA",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M341.5 416C269.769 196 361.5 -248 361.5 -248L-39.5 -156L-89 1435.5L152 1472C152 1472 411 1493.5 361.5 1383.5C312 1273.5 421.829 662.368 341.5 416Z",
    fill: "#FFEDFA",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M348 296.5C391 38 373.5 -437 373.5 -437L-27.5 -345L-77 1246.5L164 1283C164 1283 423 1304.5 373.5 1194.5C324 1084.5 305.479 552.121 348 296.5Z",
    fill: "#FFEDFA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -347.797,
    cy: 196.203,
    r: 1178.2,
    fill: "url(#paint0_radial_23_126)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_23_126",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-347.797 196.203) rotate(90) scale(1178.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.f9b5c535eb3b914caf8e58bec61547fe.svg";
export { ForwardRef as ReactComponent };